import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface LanguageSelectorProps {
  onSelect: (lang: string) => void;
}
export function LanguageSelector({
  onSelect
}: LanguageSelectorProps) {
  const [isExiting, setIsExiting] = useState(false);
  const [selectedLang, setSelectedLang] = useState<string | null>(null);
  const handleSelect = (lang: string) => {
    setSelectedLang(lang);
    setIsExiting(true);
    setTimeout(() => {
      onSelect(lang);
    }, 500);
  };
  return <motion.div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-brand-black px-4" initial={{
    opacity: 1,
    scale: 1
  }} animate={isExiting ? {
    opacity: 0,
    scale: 0.95
  } : {
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} data-id="element-78">
      {/* Logo */}
      <motion.div className="mb-10 w-40 h-40 flex items-center justify-center" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} data-id="element-79">
        <img src="https://cdn.magicpatterns.com/uploads/gbD8hKufJEC7SSgGgGcMCM/IMG_8096.jpg" alt="OJ Auto Group LLC Logo" className="max-w-full max-h-full object-contain" data-id="element-80" />
      </motion.div>

      {/* Headings */}
      <motion.div className="text-center mb-12" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} data-id="element-81">
        <h1 className="text-4xl md:text-5xl text-white font-heading uppercase tracking-wide mb-3" data-id="element-82">
          Select Your Language
        </h1>
        <p className="text-xl text-gray-400 font-body" data-id="element-83">Seleccione su idioma</p>
      </motion.div>

      {/* Language Cards */}
      <motion.div className="flex flex-col sm:flex-row gap-6 w-full max-w-2xl" initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} data-id="element-84">
        {/* English Card */}
        <button onClick={() => handleSelect('en')} className={`flex-1 flex flex-col items-center justify-center p-8 bg-brand-dark border rounded-xl transition-all duration-300 min-h-[160px] group ${selectedLang === 'en' ? 'border-brand-red shadow-[0_0_20px_rgba(255,0,0,0.3)]' : 'border-gray-800 hover:border-brand-red hover:shadow-[0_0_15px_rgba(255,0,0,0.2)]'}`} data-id="element-85">
          <img src="https://flagcdn.com/w80/us.png" srcSet="https://flagcdn.com/w160/us.png 2x" alt="USA Flag" className="w-16 h-12 object-cover rounded mb-4" data-id="element-86" />
          <span className="text-2xl text-white font-heading uppercase tracking-wide mb-2" data-id="element-87">
            English
          </span>
          <span className="text-gray-400 font-body text-sm" data-id="element-88">
            Continue in English
          </span>
        </button>

        {/* Spanish Card */}
        <button onClick={() => handleSelect('es')} className={`flex-1 flex flex-col items-center justify-center p-8 bg-brand-dark border rounded-xl transition-all duration-300 min-h-[160px] group ${selectedLang === 'es' ? 'border-brand-red shadow-[0_0_20px_rgba(255,0,0,0.3)]' : 'border-gray-800 hover:border-brand-red hover:shadow-[0_0_15px_rgba(255,0,0,0.2)]'}`} data-id="element-89">
          <img src="https://flagcdn.com/w80/es.png" srcSet="https://flagcdn.com/w160/es.png 2x" alt="Spain Flag" className="w-16 h-12 object-cover rounded mb-4" data-id="element-90" />
          <span className="text-2xl text-white font-heading uppercase tracking-wide mb-2" data-id="element-91">
            Español
          </span>
          <span className="text-gray-400 font-body text-sm" data-id="element-92">
            Continuar en Español
          </span>
        </button>
      </motion.div>

      {/* Subtle branding */}
      <motion.p className="mt-10 text-gray-600 font-body text-xs sm:text-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} data-id="element-93">
        OJ Auto Group LLC — 24/7 Towing & Car Rental
      </motion.p>
    </motion.div>;
}